import { render, staticRenderFns } from "./ContactService.vue?vue&type=template&id=639d6f96"
import script from "./ContactService.vue?vue&type=script&lang=js"
export * from "./ContactService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports